import Link from 'next/link'
import Image from 'next/legacy/image'
import useIntersectionObserver from '~~/src/hooks/deepcity-ux/useIntersectionObserver'
import { Box, Skeleton } from '@mui/material'
import { Logo } from "../Main/utils/Assets"

const style = {
  wrapper: `flex px-2`,
  logoContainer: `w-16 h-16 pt-1`,
  brandName: `dark:text-blue-50 text-slate-800 font-bold text-3xl`,
  backBtn: `text-2xl cursor-pointer duration-200 ease-out hover:scale-105 absolute -left-4 dark:text-slate-500 text-slate-200`
}

export default function LogoBanner() {
  const [shouldLoad, targetRef] = useIntersectionObserver()

  return (
    <div className={style.wrapper}>
      <div className={style.logoContainer}>
        {shouldLoad ?
          <div className='relative w-12 h-12 mx-auto my-2'>
            <Link href={`/`} aria-label={'Go to Deepcity home page'} >
              <Image
                src={Logo}
                width={100}
                height={100}
                alt='Deepcity logo'
                layout='responsive'
                objectFit='contain'
              />
            </Link>
            <strong
              style={{ "fontSize": '20px', "lineHeight": '10px' }}
              className={`text-black dark:text-white font-extrabold absolute left-14 bottom-2 sm:hidden`}
            >
              BETA
            </strong>
          </div>
          :
          <Box ref={targetRef} >
            <Skeleton variant='rectangular' className='w-12 h-14' />
          </Box>
        }
      </div>
      <div className='relative my-4 hidden sm:block'>
        <Link href={`/`} aria-label={'Go to Deepcity home page'} className={style.brandName}>
          DeepCity
        </Link>
        <strong
          style={{ "fontSize": '14px', "lineHeight": '10px' }}
          className={`text-black dark:text-white font-extrabold absolute right-2 bottom-0`}
        >
          BETA
        </strong>
      </div>
    </div >
  )
}
